/**
 * Matcher for behavior rules
 * @module
 */

var _ = require('optimizely-client-fn');
var JSONEnv = require('core/lib/json');
var rule_builder = require('../../helpers/rule_builder');
var rules = require('../../helpers/rules');

module.exports = {
  fieldsNeeded: [
    'events',
  ],

  /**
   * Return whether the rule represented by cond.value is satisfied by value.events
   * @param {Object} value
   * @param {Object[]} value.events
   * @param {Object} cond
   * @param {string} cond.value
   * @returns {boolean}
   */
  match: function(value:any, cond:any): boolean {
    var rulesToTest = [];
    var ruleSpec = JSONEnv.parse(cond.value);
    // JSON stringified rules do not have a 'version' field.
    if (_.isUndefined(ruleSpec.version)) {
      // TODO(ajith): Remove once old BT audiences are migrated and TGT-1455 is closed.
      // The spec is the rule itself.
      rulesToTest = [ruleSpec];
    } else {
      // Build rules from the spec.
      rulesToTest = rule_builder.buildFromSpecV0_1(ruleSpec);
    }

    // Every rule must be satisfied.
    return _.every(rulesToTest, function(rule) {
      return rules.isSatisfied(rule, value.events);
    });
  },
};
